var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrganizationForm',{attrs:{"loading":_vm.loading,"initial":_vm.initial},on:{"update":function($event){return _vm.updateHandler($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }